module.exports = __webpack_public_path__ + "img/img-staffAccountmanage.54ae2ac8.png";